import React from 'react';
import clone from 'clone';
import EditSectionInput from './EditSectionInput';
import EditSectionDateTime from './EditSectionDateTime';
import EditSectionDropdown from './EditSectionDropdown';
import EditSectionCheckBox from './EditSectionCheckBox';
import Alerts from '../prototypes/Alerts';
import EtelAPI from '../api/EtelAPI';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter
} from './Dialog';


// Utility function to validate datetime input values
function validateDateTimeInput( value ){
  // Format / does not do well with int conversions
  // -- we need to extract the values
  if( value.length !== 10 ){
    return false;
  } else {
    if( date2Integer( value ).toString().length !== 8 ){
      return false;
    } else {
      return true;
    }
  }
}

// Utility function to convert MM/DD/YYYY to YYYYMMDD base int
function date2Integer( value ){
  const mm = value.substring( 0, 2 );
  const dd = value.substring( 3, 5 );
  const yyyy = value.substring( 6, 10 );

  return parseInt( yyyy + mm + dd, 10 );
}

// Utility function to convert YYYYMMDD to MM/DD/YYYY
function CCDateToUSDate( value ){

  // Convert the value data to a string
  let strValue = value.toString();
  return (
    // xxxxMMxx                         xxxxxxDD                         YYYYxxxx
    strValue.substring( 4, 6 ) + '/' + strValue.substring( 6, 8 ) + '/' + strValue.substring( 0, 4 )
  );
}

// Utility function to return proper value if input is undefined
function readValue( state, key ){
  if( state ){
    let value = state[key];
    if( value === undefined || value === null ){
      return '';
    }
    return value;
  } else {
    return '';
  }
}

// Utility function to return a MM/DD/YYYY
function formatValue( datevalue ){
  if( datevalue ){
    let value = datevalue.toString();
    const year = value.substring( 0, 4 );
    const month = value.substring( 4, 6 );
    const day = value.substring( 6, 8 );
    return month + '/' + day + '/' + year;
  } else {
    return '';
  }
}

// Validates if it's a future fee (utility function)
// @arg: currentDate[int] -> YYYYMMDD of today (or when component was initialized), this value is passed in from the
//       parent (FeesList)
// @arg: beginDate[int] -> The value supplied by the row, YYYYMMDD format as well
function isFutureFee( currentDate, beginDate ){
  if( currentDate > beginDate ){
    return false;
  } else {
    return true;
  }
}

// Returns True if fee out of period for an edit
function isFeeOutOfPeriod( currentPeriodCutoff, editFeeStart ){
  if( editFeeStart === '' ){
    return false; // Can not determine
  } else {
    const intDate = parseInt( currentPeriodCutoff.substring( 0, 4 ) + currentPeriodCutoff.substring( 5, 7 ) + currentPeriodCutoff.substring( 8, 10 ), 10 );
    if( editFeeStart >= intDate ){
      return false; // Fee is within range
    } else {
      return true; // Fee is out of range (old)
    }
  }
}

// ProgramFeeDialog, show current on edit, or future + current on copy
class ProgramFeesDialog extends React.Component {

  constructor( props ){
    super( props );

    // Adjusting height for the new row if dialog is a copy
    // --note, these style are hard coded in componentWillReceiveProps
    let dialogHeight = '530px';
    if( props.dialogType === 'copy' ){
      dialogHeight = '580px';
    }

    this.state = {
      height: dialogHeight,
      width: '1300px',
      rowRef: props.row,
      copySourceRow: clone( props.row ),
      dialogType: props.dialogType,
      errorMessage: '',
      allowSave: true
      // utilityCurrentDate: this.props.utilityCurrentDate (use props - not state)
    };

    this.onCancelClicked = this.onCancelClicked.bind( this );
    this.getLocation = this.getLocation.bind( this );
    this.renderBody = this.renderBody.bind( this );
    this.onChangeItemEvent = this.onChangeItemEvent.bind( this );
    this.onSaveChanges = this.onSaveChanges.bind( this );
    this.onCheckBoxClicked = this.onCheckBoxClicked.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
    this.getFeeState = this.getFeeState.bind( this );
    this.getFeeTypes = this.getFeeTypes.bind( this );
    this.getFeeBase = this.getFeeBase.bind( this );
    this.dropdownChanged = this.dropdownChanged.bind( this );
    this.onCopy = this.onCopy.bind( this );
    this.onChangePreviousDateEnd = this.onChangePreviousDateEnd.bind( this );
    this.onValidateInput = this.onValidateInput.bind( this );
    this.renderEditMode = this.renderEditMode.bind( this );
    this.renderCopyMode = this.renderCopyMode.bind( this );
    this.validateCheckDates = this.validateCheckDates.bind( this );
    this.writeError = this.writeError.bind( this );
    this.clearErrorOnChange = this.clearErrorOnChange.bind( this );

    // Event handlers for datetimes
    this.onChangeDateBegin = this.onChangeDateBegin.bind( this );
    this.onChangeDateEnd = this.onChangeDateEnd.bind( this );

    // Dropdown Options
    // *note: Out of state values to limit renders, these will get set on 
    //  the dialog loading (not shown) and the state will be updated to
    //  show on click, but these paths do not need to be executed again
    this.FeeStateTypes = [];
    this.FeeTypeTypes = [];
    this.FeeBaseTypes = [];

    // These are mapped to the dropsdown on columnName
    this.FeeColumnKeys = {
      1:'FEE_STATE_ID', 2:'FEE_TYPE_ID', 3:'FEE_BASE_ID'
    };

    // Error messages placed by writeError, this allows for multiple errors to exist but error that must
    // be fixed in the UI before saving (proc) can be executed
    // Keys get filled in by the values passed in
    this.ValidationTable = {};

    // Check before rending
    this._ismounted = false;
  }

  // Getting the options for the dropdowns once the component has mounted
  componentDidMount(){
    this._ismounted = true;
    this.getFeeState(); // -- FeeStateTypes
    this.getFeeTypes(); // -- FeeTypeTypes
    this.getFeeBase(); // -- FeeBaseTypes
  }

  componentWillUnmount(){
    this._ismounted = false;
  }

  // Values passed down, different behavior depending on the mode of the current dialog
  // Copying future fees will took a look at the date of the previous and set to end it
  // on X + 1 date, based on the previous Future fee, this condition only applies to future
  // fess.
  componentWillReceiveProps( nextProps ) {

    // When new procs are passed in, we need to clear the ValidationTable, as these error
    // will be cleared on closing
    this.ValidationTable = {};

    // Fetching utilityCurrentDate (YYYYMMDD)
    let utilityCurrentDate = this.props.utilityCurrentDate;
    if( utilityCurrentDate === undefined ){
      utilityCurrentDate = nextProps.utilityCurrentDate;
    }

    // Altering a copy of the ref row since we are going to make a new copy
    if( nextProps.dialogType === 'copy' ){

      // The two rows + from copy
      let copyrow = clone( nextProps.row );
      let sourceRow = nextProps.row;

      // Copy of a feature fee
      if( isFutureFee( utilityCurrentDate, sourceRow.CCFileDateBegin ) === true ){
        
        // Instead of today, we are going to be using the CCFileDateBegin of prior        
        let prevEnd = ( sourceRow.CCFileDateBegin ).toString();
        prevEnd = ( prevEnd.substring( 0,4 ) + '-' + prevEnd.substring( 4,6 ) + '-' + prevEnd.substring( 6, 8 ) );
        prevEnd = new Date( prevEnd );

        // Setting the previos date. Then extracting the YYYYMMDD values
        prevEnd.setDate( prevEnd.getDate() + 2 );
        const prevDay = String( prevEnd.getDate() ).padStart( 2, '0' );
        const prevMonth = String( prevEnd.getMonth() + 1 ).padStart( 2, '0' ); // Takes care of 0 for January, dumb JS...
        const prevYear = prevEnd.getFullYear();

        sourceRow['CCFileDateEnd'] = parseInt( prevYear + prevMonth + prevDay, 10 );

        // Setting the new prevEnd value for the new row to be + 2 total (+2 then +1 ~ objects)
        prevEnd.setDate( prevEnd.getDate() + 1 );
        const nextDay = String( prevEnd.getDate() ).padStart( 2, '0' );
        const nextMonth = String( prevEnd.getMonth() + 1 ).padStart( 2, '0' ); // Takes care of 0 for January, dumb JS...
        const nextYear = prevEnd.getFullYear();

        copyrow['CCFileDateBegin'] = parseInt( nextYear + nextMonth + nextDay, 10 );
        copyrow['CCFileDateEnd'] = 20991231;

        // These are set to 0 for a new row
        if( copyrow['PGM_FEE_ID'] === undefined ){
          copyrow['PGM_FEE_ID'] = 0;
          copyrow['LEGACY_ID'] = 0;
        }

        // Updating state
        this.setState( {
          rowRef: copyrow,
          copySourceRow: sourceRow,
          dialogType: 'copy',
          height: '580px'
        } );

      // Copy of a current fee
      } else {
        // Setting the begin date to tomorrow, setting the original end date to today
        let today = new Date(); // Copy from Row end date

        // New Row's start date
        let tomorrow = new Date( today.setDate( today.getDate() + 1 ) ); // Inner method returns an int

        // Using today values for the copy row, the user can change this and will alter the old row by this value
        let day = String( tomorrow.getDate() ).padStart( 2, '0' );
        let month = String( tomorrow.getMonth() + 1 ).padStart( 2, '0' ); // Takes care of 0 for January, dumb JS...
        let year = tomorrow.getFullYear();

        // Reset back to today
        today.setDate( today.getDate() - 1 );
        let endDay = String( today.getDate() ).padStart( 2, '0' );
        let endMonth = String( today.getMonth() + 1 ).padStart( 2, '0' );
        let endYear = today.getFullYear();

        // Defaults
        copyrow['CCFileDateBegin'] = parseInt( year + month + day, 10 );
        sourceRow['CCFileDateEnd'] = parseInt( endYear + endMonth + endDay, 10 );
        copyrow['CCFileDateEnd'] = 20991231;

        // These are set to 0 for a new row
        if( copyrow['PGM_FEE_ID'] === undefined ){
          copyrow['PGM_FEE_ID'] = 0;
          copyrow['LEGACY_ID'] = 0;
        }

        // Updating state
        this.setState( {
          rowRef: copyrow,
          copySourceRow: sourceRow,
          dialogType: 'copy',
          height: '580px'
        } );
      }
    } else {
      this.setState( {
        rowRef: nextProps.row,
        copySourceRow: clone( nextProps.row ),
        dialogType: nextProps.dialogType,
        height: '530px'
      } );
    }
  }

  // Handle exceptions
  onHandleException( e ) {
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );

    if( e.statusText !== undefined ) {
      alerts.CRITICAL( 'Program Fee Dialog', e.statusText );
    } else {
      alerts.CRITICAL( 'Program Fee Dialog', 'Unhandled exception occurred.' );
    }
  }

  // Gets the fee state types
  getFeeState() {
    let api = new EtelAPI( 'types/programfeestatetypes' );
    
    api.get( {} ).then( ( result ) => {
      // Fetches on results for id and text
      let data = [];
      for( let i = 0; i < result.length; i++ ){
        const row = result[i];
        data.push( { id: row['TYPE_FEE_STATE_ID'], text: row['NAME']} );
      }

      // Update internal object if React-DOM is mounted for this component
      if( this._ismounted === true ){
        this.FeeStateTypes = data;
      }
    
    // On error
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Gets the fee type types
  getFeeTypes() {
    let api = new EtelAPI( 'types/programfeetypes' );
    
    api.get( {} ).then( ( result ) => {
      // Fetches on results for id and text
      let data = [];
      for( let i = 0; i < result.length; i++ ){
        const row = result[i];
        data.push( {id: row['Fee_Type_ID'], text: row['NAME']} );
      }

      // Update internal object if React-DOM is mounted for this component
      if( this._ismounted === true ){
        this.FeeTypeTypes = data;
      }

    // On error
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }
  
  // Gets the fee base types
  getFeeBase() {
    let api = new EtelAPI( 'types/programfeebasetypes' );
    
    api.get( {} ).then( ( result ) => {
      // Fetches on results for id and text
      let data = [];
      for( let i = 0; i < result.length; i++ ){
        const row = result[i];
        data.push( {id: row['Fee_Base_ID'], text: row['CODE']} );
      }

      // Update internal object if React-DOM is mounted for this component
      if( this._ismounted === true ){
        this.FeeBaseTypes = data;
      }

    // On error
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Returns the positioning of the dialog based on current sidebar position
  getLocation(){
    let view = document.getElementById( 'ListContainerGridView' );
    if( view ){
      let parent_width = view.offsetWidth;
      let parent_height = view.offsetHeight;
      let sub = 50; // Expanded by default

      // Adjusts for sidebar, does not account for window size
      const sidebar_collapsed = document.getElementsByClassName( 'sidebar-collapsed' );
      if( sidebar_collapsed.length !== 0 ){
        sub = 35;
      }

      if( this.state.dialogType === 'edit' ){
        return {x: ( parent_width / 8 ) - sub, y: parent_height / 4 };
      } else {
        return {x: ( parent_width / 8 ) - sub, y: parent_height / 5 };
      }
    
    // Pre-mount (DOM element not available)
    } else {
      return undefined;
    }
  }

  // Clears inability to save because validation proc came back, this will validate
  clearErrorOnChange(){
    if( this._ismounted === true ){
      this.ValidationTable = {};
      this.setState( {
        errorMessage: '',
        allowSave: true
      } );
    }
  }

  // Fires once a dropdown changes
  dropdownChanged( e ){

    if( e && e.target !== undefined && this._ismounted === true ){
      const target = e.target;
      const keys = this.FeeColumnKeys;

      let newReferenceRow = this.state.rowRef;
      newReferenceRow[ keys[target.column] ] = target.value;
      
      // Saving the value
      this.setState( {
        rowRef: newReferenceRow
      } );
    }
  }

  // Removes the dialog and allows interaction on the site again
  onCancelClicked( e ){
    if( this._ismounted === true ){

      // Clearing the component object inner prop (none state)
      this.ValidationTable = {};
 
      if( this.props.onCancel !== undefined ){
        this.setState( {
          show: false,
          errorMessage: '',
          allowSave: true
        }, this.props.onCancel( e ) );
      } else {
        this.setState( {
          show: false,
          errorMessage: '',
          allowSave: true
        } );
      }
    }
  }

  // Writes disables Saving on the component if something is invalid
  writeError( key, msg, overide_button ){
    // Writting the message
    this.ValidationTable[key] = msg;

    // Validating no messages remain
    let keys = Object.keys( this.ValidationTable );
    let keyMessage = '';
    let hasError = false;
    
    for( let i = 0; i < keys.length; i++ ){
      keyMessage = this.ValidationTable[ keys[i] ];

      if( keyMessage !== '' ){
        hasError = true;
        break;
      }
    }

    // This option is if the save/copy is allowed but only to verify with the backend, posting to a save or copy will be stopped
    // until this error is cleared
    if( this.overide_button === true ){
      this.setState( {
        errorMessage: keyMessage,
        allowSave: true
      } );
    } else {
      this.setState( {
        errorMessage: keyMessage,
        allowSave: !hasError
      } );
    }
  }

  // Handles changes coming from components
  // @arg: e[ProxyEvent] -> Fired by the component being altered
  onChangeItemEvent( e ) {
    const target = e.target;
    if( target ){
      const key = target.column;
      const value = target.value;
      let operation = '';
      let newReferenceRow = this.state.rowRef;
      newReferenceRow[key] = value;

      // Clear the error on change
      this.clearErrorOnChange();

      // Validation step, these operations used to be part of a proc,
      // however said proc was updated and simplified and that logic
      // is handled on the ui, the operations are kept to indicate in
      // the original source what these checks go to
      if( key === 'FeeRate' ){

        operation = 'FEE';
        // Validation is done in here
        if( isNaN( value ) === true ){
          this.writeError( operation, 'Error: Fee is invalid' );
        } else if( value === '' ){
          this.writeError( operation, 'Error: Fee can not be empty' );

          // Must convert value to a number as abs on 9.10 will yield 9.1 which is not the same as 9.10, this fixes that check
        } else if( Number( value ).toString() !== Math.abs( value ).toString() ){
          this.writeError( operation, 'Error: Fee can not be negative' );
        } else {
          this.writeError( operation, '', false );
        }
      } else if ( key === 'XX_Seconds_ToBeBillable' ) {
        
        operation = 'BILL-SECONDS';
        // Validation is done in here
        if( isNaN( value ) === true ){
          this.writeError( operation, 'Error: Seconds Billable is invalid' );
        } else if( value === '' ){
          this.writeError( operation, 'Error: Seconds Billable can not be empty' );

          // Must convert value to a number as abs on 9.10 will yield 9.1 which is not the same as 9.10, this fixes that check
        } else if( Number( value ).toString() !== Math.abs( value ).toString() ){
          this.writeError( operation, 'Error: Seconds Billable can not be negative' );
        } else {
          this.writeError( operation, '' );
        }
      }
      // End of UI Validation

      this.setState( {
        rowRef: newReferenceRow
      } );
    }
  }

  // All changes are held locally until saved, which then is passed to the parent to be
  // committed to the backend
  onSaveChanges() {

    // Send to backend for extra validation if it comes back ok, then we're ok to save
    const api = new EtelAPI( 'programs/pgmfeesvalidation' );
    const rowRef = this.state.rowRef;
    const copySourceRow = this.state.copySourceRow;

    let LEGACY_ID = rowRef['LEGACY_ID'];
    if( LEGACY_ID === null || LEGACY_ID === undefined ){
      LEGACY_ID = 0;
    }

    // Passed into the validation proc
    let validation_payload = {
      DNIS: copySourceRow['PDNIS'],
      Original_DateBegin: copySourceRow['CCFileDateBegin'],
      Original_DateEnd: copySourceRow['CCFileDateEnd'],
      New_DateBegin: rowRef['CCFileDateBegin'],
      New_DateEnd: rowRef['CCFileDateEnd'],
      Operation: 'EDIT'
    };

    //  Params passed in as a post (insert in the api)
    api.insert( validation_payload ).then( ( result ) => {
      let message = result.data[0];
      if( message.RESULT !== '' ){

        if( message.RESULT.includes( 'Error:' ) === true ){
          // Disable the ability to Save or Copy if an error is found
          this.writeError( 'VALIDATION_PROC', message.RESULT, true );
        
        // Warning / none error
        } else {
          this.writeError( 'VALIDATION_PROC', message.RESULT );
        }
      } else {
        this.writeError( 'VALIDATION_PROC', message.RESULT );
      }

      // Save to proc (parent)
      if( this.props.onSave !== undefined && this.ValidationTable['VALIDATION_PROC'] === '' ){
        this.props.onSave( rowRef );
      }
      
    // If proc error 
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Pre-db validation, copied from BB, reformated for modern JS. These are UI side validations
  validateCheckDates( requestType ) {
    let origBegin = this.state.copySourceRow['CCFileDateBegin'];
    let origEnd = this.state.copySourceRow['CCFileDateEnd'];
    let newBegin = this.state.rowRef['CCFileDateBegin'];
    let newEnd = this.state.rowRef['CCFileDateEnd'];

    /*
    / DATES-EDIT
    */
    if( requestType === 'DATES-EDIT' ){
      
      // IF the new end date for the old row is < the begin date for old row, error
      if( origBegin > newEnd ){
        return 'Error: The new End Date must be > ' + CCDateToUSDate( origBegin ) + ' (jCR0)';
      }

      // IF the new end date for the old row is >= the begin date for the new row, error
      if( newEnd < newBegin ) {
        return 'Error: The new Begin Date must be > ' + CCDateToUSDate( newEnd ) + ' (jCR1)';
      }

      // IF the new end date is >= the new end date, error
      if ( newBegin >= newEnd ) {
        return 'Error: The new End Date must be > ' + CCDateToUSDate( newBegin ) + ' (jCR2)';
      }
    
    /*
    / DATES-COPY-NEW-END-DATE or DATES-COPY
    */
    } else if( requestType === 'DATES-COPY-NEW-END-DATE' || requestType === 'DATES-COPY' ) {
      
      // IF the new end date for the old row is >= the begin date for the new row, error
      if( origEnd >= newBegin ) {
        return 'Error: The new Begin Date must be > ' + CCDateToUSDate( origEnd ) + ' (jCR1)';
      }

    /*
    / ??? Future changes ???
    */
    } else {
      
      // IF the new end date for the old row is >= the begin date for the new row, error
      if( origEnd >= newBegin ) {
        return (
          'Error: The new Begin Date must be < ' + CCDateToUSDate( origEnd ) +
            ', or the new End Date must be > ' + CCDateToUSDate( newBegin ) + ' (jDE1)'
        );
      }
    }

    return '';
  }


  // Toggles clickable settings
  onCheckBoxClicked( e ){
    if( e && e.target !== undefined ){
      const key = e.target.id;
      let newReferenceRow = this.state.rowRef;
      newReferenceRow[key] = e.target.value;
      this.setState( {
        rowRef: newReferenceRow
      } );
    }
  }

  // Changes the datetime value for the starting date
  onChangeDateBegin( e ){
    if( e && e.target && validateDateTimeInput( e.target.value ) === true ){
      // Check to make sure the end string is bigger than the new string
      const endTime = this.state.rowRef['CCFileDateEnd'];
      const value = date2Integer( e.target.value );

      let operation = '';
      if( this.state.dialogType === 'edit' ){
        operation = 'DATES-EDIT';
      } else {
        operation = 'DATES-COPY';
      }

      // Changing the state
      let newReferenceRow = this.state.rowRef;
      newReferenceRow['CCFileDateBegin'] = value; // Note, this value is an integer

      // Making sure end time is always bigger than beginning time
      if( endTime > value ){
        this.setState( {
          rowRef: newReferenceRow
        }, this.onValidateInput( operation ) );
      } else {
        this.setState( {
          rowRef: newReferenceRow
        }, this.writeError( operation, 'Error: End Date must be bigger than Begin Date' ) );
      }
    }
  }

  // Changes the datetime value for the ending date
  onChangeDateEnd( e ){
    if( e && e.target && validateDateTimeInput( e.target.value ) === true ){
      // Check to make sure the end string is bigger than the new string
      const startTime = this.state.rowRef['CCFileDateBegin'];
      const value = date2Integer( e.target.value );

      let operation = '';
      if( this.state.dialogType === 'edit' ){
        operation = 'DATES-EDIT';
      } else {
        operation = 'DATES-COPY';
      }

      let newReferenceRow = this.state.rowRef;
      newReferenceRow['CCFileDateEnd'] = value; // Note, this value is an integer

      // Making sure end time is always bigger than beginning time
      if( value > startTime ){
        this.setState( {
          rowRef: newReferenceRow
        }, this.onValidateInput( operation ) );
      } else {
        this.setState( {
          rowRef: newReferenceRow
        }, this.writeError( operation, 'Error: End Date must be bigger than Begin Date' ) );
      }
    }
  }

  // On a copy, edits to the previous end date
  onChangePreviousDateEnd( e ){
    if( e && e.target && validateDateTimeInput( e.target.value ) === true ){

      // Operation to validate
      let operation = 'DATES-COPY-NEW-END-DATE';
      let previousEndDateRow = this.state.copySourceRow;

      // Int value parsed from string
      const value = date2Integer( e.target.value );
      previousEndDateRow['CCFileDateEnd'] = value;

      this.setState( {
        copySourceRow: previousEndDateRow
      }, this.onValidateInput( operation ) );
    }
  }

  // Calls the parents onCopy to save the values
  onCopy( e ){
    // Send to backend for extra validation if it comes back ok, then we're ok to save
    const api = new EtelAPI( 'programs/pgmfeesvalidation' );
    const rowRef = this.state.rowRef;
    const copySourceRow = this.state.copySourceRow;

    let LEGACY_ID = rowRef['LEGACY_ID'];
    if( LEGACY_ID === null || LEGACY_ID === undefined ){
      LEGACY_ID = 0;
    }

    // Passed into the validation proc
    let validation_payload = {
      DNIS: copySourceRow['PDNIS'],
      Original_DateBegin: copySourceRow['CCFileDateBegin'],
      Original_DateEnd: copySourceRow['CCFileDateEnd'],
      New_DateBegin: rowRef['CCFileDateBegin'],
      New_DateEnd: rowRef['CCFileDateEnd'],
      Operation: 'COPY'
    };

    //  Params passed in as a post (insert in the api)
    api.insert( validation_payload ).then( ( result ) => {

      let message = result.data[0];
      if( message.RESULT !== '' ){

        if( message.RESULT.includes( 'Error:' ) === true ){
          // Disable the ability to Save or Copy if an error is found
          this.writeError( 'VALIDATION_PROC_COPY', message.RESULT, true );
        
        // Warning / none error
        } else {
          this.writeError( 'VALIDATION_PROC_COPY', message.RESULT );
        }
      } else {
        this.writeError( 'VALIDATION_PROC_COPY', message.RESULT );
      }

      // Save to proc (parent)
      if( this.props.onSave !== undefined && this.ValidationTable['VALIDATION_PROC_COPY'] === '' ){
        this.props.onCopy( rowRef, this.state.copySourceRow );
      }
      
    // If proc error 
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Performed before the save (POST) can be done, this is UI side for dates
  onValidateInput( operation ){
    if( operation !== '' ){
      
      let payload = {};
      // Only dates are validated by this proc / validation
      if ( operation === 'DATES-EDIT' ) {
        payload = {
          PGM_FEE_ID: this.state.copySourceRow['PGM_FEE_ID'],
          AD_ID: this.state.rowRef['AD_ID'],
          CCFileDateBegin: this.state.rowRef['CCFileDateBegin'],
          CCFileDateEnd: this.state.rowRef['CCFileDateEnd'],
          Operation: 'DATES-EDIT'
        };
      } else if ( operation === 'DATES-COPY-NEW-END-DATE' ) {
        payload = {
          PGM_FEE_ID: this.state.copySourceRow['PGM_FEE_ID'],
          PDNIS: this.state.copySourceRow['PDNIS'],
          AD_ID: this.state.copySourceRow['AD_ID'],
          CCFileDateBegin: this.state.copySourceRow['CCFileDateEnd'],
          CCFileDateEnd: this.state.rowRef['CCFileDateEnd'],
          // Operation: 'DATES-COPY-NEW-END-DATE'
          Operation: 'DATES-COPY'
        };
      } else if ( operation === 'DATES-COPY' ) {
        payload = {
          PGM_FEE_ID: this.state.copySourceRow['PGM_FEE_ID'],
          PDNIS: this.state.rowRef['PDNIS'],
          AD_ID: this.state.rowRef['AD_ID'],
          CCFileDateBegin: this.state.rowRef['CCFileDateBegin'],
          CCFileDateEnd: this.state.copySourceRow['CCFileDateEnd'],
          Operation: 'DATES-COPY'
        };
      }

      // Let validate with the UI
      let uiValidation = this.validateCheckDates( payload['Operation'] );
      this.writeError( payload['Operation'], uiValidation );
    }
  }

  // Renders a single line view of the values using rowRef as the change row
  renderEditMode( isReadOnly ){
    let readOnlyCheckColor = 'black';
    if( isReadOnly === true ){
      readOnlyCheckColor = 'lightgrey';
    }

    return(
      <div>
        <div className={'program-fees-dialog-edit-section'}>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Company </div>
            <EditSectionInput styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.rowRef, 'CompanyName' ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> PDNIS </div>
            <EditSectionInput styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.rowRef, 'PDNIS' ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-19'}>
            <div> Program Name </div>
            <EditSectionInput styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.rowRef, 'PROGRAM_NAME' ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5'}>
            <div> Active </div>
            <EditSectionCheckBox id='ACTIVE' checked={ readValue( this.state.rowRef, 'ACTIVE' ) === 1 ? true : false} readOnly={true} checkColor={'lightgrey'}/>
          </div>
          <div className={'dialog-position-left'} />
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee State </div>
            <EditSectionDropdown columnName={1} value={readValue( this.state.rowRef, 'FEE_STATE_ID' )} readonly={isReadOnly} options={this.FeeStateTypes} onChanged={this.dropdownChanged}/>
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee Type </div>
            <EditSectionDropdown columnName={2} value={ readValue( this.state.rowRef, 'FEE_TYPE_ID' )} readonly={isReadOnly} options={this.FeeTypeTypes} onChanged={this.dropdownChanged}/>
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee Based On </div>
            <EditSectionDropdown columnName={3} value={ readValue( this.state.rowRef, 'FEE_BASE_ID' )} readonly={isReadOnly} options={this.FeeBaseTypes} onChanged={this.dropdownChanged}/>
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-3'}>
            <div> Ad Id </div>
            <EditSectionInput columnName={'AD_ID'} value={ readValue( this.state.rowRef, 'AD_ID' ) } readonly={isReadOnly} onChanged={this.onChangeItemEvent} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5'}>
            <div> Fee Rate </div>
            <EditSectionInput autoFocus={true} columnName={'FeeRate'} value={ readValue( this.state.rowRef, 'FeeRate' ) } readonly={isReadOnly} onChanged={this.onChangeItemEvent} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-9'}>
            <div> Seconds Billable </div>
            <EditSectionInput columnName={'XX_Seconds_ToBeBillable'} value={ readValue( this.state.rowRef, 'XX_Seconds_ToBeBillable' ) } readonly={isReadOnly} onChanged={this.onChangeItemEvent} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-15'}>
            <div> Begin Date </div>
            <EditSectionDateTime id={1} columnName={1} value={ readValue( this.state.rowRef, 'CCFileDateBegin' ) } width={'40px'} readonly={isReadOnly} onChange={this.onChangeDateBegin} dateFormat={'MM/DD/YYYY'} timeFormat={false} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-15'}>
            <div> End Date </div>
            <EditSectionDateTime id={2} columnName={2} value={ readValue( this.state.rowRef, 'CCFileDateEnd' ) } width={'40px'} readonly={isReadOnly} onChange={this.onChangeDateEnd} dateFormat={'MM/DD/YYYY'} timeFormat={false} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5 relative-position'}>
            <div> Auto Compute Bill Secs </div>
            <EditSectionCheckBox id='AutoComputeBillableCalls' checked={ readValue( this.state.rowRef, 'AutoComputeBillableCalls' ) === 1 ? true : false} checkColor={readOnlyCheckColor} readOnly={isReadOnly} onChanged={this.onCheckBoxClicked} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5 relative-position'} style={{marginRight:'4px'}}>
            <div> Auto Compute Revenue </div>
            <EditSectionCheckBox id='AutoComputeRevenue' checked={ readValue( this.state.rowRef, 'AutoComputeRevenue' ) === 1 ? true : false} checkColor={readOnlyCheckColor} readOnly={isReadOnly} onChanged={this.onCheckBoxClicked} />
          </div>
        </div>
      </div>
    );
  }

  // Render two line views (think spreadsheet) using copySourceRow as the previous row, and rowRef as the new row
  renderCopyMode(){
    return(
      <div>
        <div className={'program-fees-dialog-readonly-section'}>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Company </div>
            <EditSectionInput styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.copySourceRow, 'CompanyName' ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> PDNIS </div>
            <EditSectionInput styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.copySourceRow, 'PDNIS' ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-19'}>
            <div> Program Name </div>
            <EditSectionInput styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.copySourceRow, 'PROGRAM_NAME' ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5'}>
            <div> Active </div>
            <EditSectionCheckBox id='ACTIVE' checked={ readValue( this.state.copySourceRow, 'ACTIVE' ) === 1 ? true : false} readOnly={true} checkColor={'lightgrey'}/>
          </div>
          <div className={'dialog-position-left'} />
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee State </div>
            <EditSectionDropdown columnName={1} value={readValue( this.state.copySourceRow, 'FEE_STATE_ID' )} options={this.FeeStateTypes} readonly={true} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee Type </div>
            <EditSectionDropdown columnName={3} value={ readValue( this.state.copySourceRow, 'FEE_TYPE_ID' )} options={this.FeeTypeTypes} readonly={true} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee Based On </div>
            <EditSectionDropdown columnName={3} value={ readValue( this.state.copySourceRow, 'FEE_BASE_ID' )} options={this.FeeBaseTypes} readonly={true} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-3'}>
            <div> Ad Id </div>
            <EditSectionInput columnName={'AD_ID'} value={ readValue( this.state.copySourceRow, 'AD_ID' ) } styles={{backgroundColor: '#F0F0F0'}} readonly={true} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5'}>
            <div> Fee Rate </div>
            <EditSectionInput columnName={'FeeRate'} value={ readValue( this.state.copySourceRow, 'FeeRate' ) } styles={{backgroundColor: '#F0F0F0'}} readonly={true} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-9'}>
            <div> Seconds Billable </div>
            <EditSectionInput columnName={'XX_Seconds_ToBeBillable'} value={ readValue( this.state.copySourceRow, 'XX_Seconds_ToBeBillable' ) } styles={{backgroundColor: '#F0F0F0'}} readonly={true} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-15'}>
            <div> Begin Date </div>
            <EditSectionInput id={1} columnName={1} styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ formatValue( readValue( this.state.copySourceRow, 'CCFileDateBegin' ) ) } />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-15'}>
            <div> End Date </div>
            <EditSectionDateTime id={2} columnName={2} focus={true} value={ readValue( this.state.copySourceRow, 'CCFileDateEnd' ) } width={'40px'} onChange={this.onChangePreviousDateEnd} dateFormat={'MM/DD/YYYY'} timeFormat={false} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5 relative-position'}>
            <div> Auto Compute Bill Secs </div>
            <EditSectionCheckBox id='AutoComputeBillableCalls' checked={ readValue( this.state.copySourceRow, 'AutoComputeBillableCalls' ) === 1 ? true : false} readOnly={true} checkColor={'lightgrey'} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5 relative-position'} style={{marginRight:'4px'}}>
            <div> Auto Compute Revenue </div>
            <EditSectionCheckBox id='AutoComputeRevenue' checked={ readValue( this.state.copySourceRow, 'AutoComputeRevenue' ) === 1 ? true : false} readOnly={true} checkColor={'lightgrey'} />
          </div>
        </div>

        <div className={'program-fees-dialog-edit-section'}>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee State </div>
            <EditSectionDropdown columnName={1} value={readValue( this.state.rowRef, 'FEE_STATE_ID' )} options={this.FeeStateTypes} onChanged={this.dropdownChanged}/>
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee Type </div>
            <EditSectionDropdown columnName={2} value={ readValue( this.state.rowRef, 'FEE_TYPE_ID' )} options={this.FeeTypeTypes} onChanged={this.dropdownChanged}/>
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-10'}>
            <div> Fee Based On </div>
            <EditSectionDropdown columnName={3} value={ readValue( this.state.rowRef, 'FEE_BASE_ID' )} options={this.FeeBaseTypes} onChanged={this.dropdownChanged}/>
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-3'}>
            <div> Ad Id </div>
            <EditSectionInput columnName={'AD_ID'} value={ readValue( this.state.rowRef, 'AD_ID' ) } onChanged={this.onChangeItemEvent} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5'}>
            <div> Fee Rate </div>
            <EditSectionInput columnName={'FeeRate'} value={ readValue( this.state.rowRef, 'FeeRate' ) } onChanged={this.onChangeItemEvent} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-9'}>
            <div> Seconds Billable </div>
            <EditSectionInput columnName={'XX_Seconds_ToBeBillable'} value={ readValue( this.state.rowRef, 'XX_Seconds_ToBeBillable' ) } onChanged={this.onChangeItemEvent} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-15'}>
            <div> Begin Date </div>
            <EditSectionDateTime id={1} columnName={1} value={ readValue( this.state.rowRef, 'CCFileDateBegin' ) } width={'40px'} onChange={this.onChangeDateBegin} dateFormat={'MM/DD/YYYY'} timeFormat={false} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-15'}>
            <div> End Date </div>
            <EditSectionDateTime id={2} columnName={2} value={ readValue( this.state.rowRef, 'CCFileDateEnd' ) } width={'40px'} onChange={this.onChangeDateEnd} dateFormat={'MM/DD/YYYY'} timeFormat={false} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5 relative-position'} style={{top: '17px'}}>
            <EditSectionCheckBox id='AutoComputeBillableCalls' checked={ readValue( this.state.rowRef, 'AutoComputeBillableCalls' ) === 1 ? true : false} onChanged={this.onCheckBoxClicked} />
          </div>
          <div className={'program-fees-dialog-readonly-section-two-item dialog-position-5 relative-position'} style={{marginRight:'4px', top: '17px'}}>
            <EditSectionCheckBox id='AutoComputeRevenue' checked={ readValue( this.state.rowRef, 'AutoComputeRevenue' ) === 1 ? true : false} onChanged={this.onCheckBoxClicked} />
          </div>
        </div>
      </div>
    );
  }

  // Renders the contents of the body
  renderBody( readonly ){
    // Edit Mode
    if( this.state.dialogType === 'edit' ) {
      return this.renderEditMode( readonly );

    // Copy Mode
    } else {
      return this.renderCopyMode();
    }
  }

  // Renders the footer section depending on the state of inputs (if error present) and the
  // dialog type
  renderFooter( readonly ){

    // Defaults to save dialog
    let buttonStyle = 'dialog-save-button';
    let clickAction = this.onSaveChanges;

    // If copy dialog
    if( this.state.dialogType === 'copy' ){
      buttonStyle = 'dialog-copy-button';
      clickAction = this.onCopy;
    }

    // Disables saves on error
    if( this.state.errorMessage !== '' || readonly === true ){
      buttonStyle = 'dialog-save-button-disabled';
      clickAction = undefined;
    }

    // Copy footer
    if( this.state.dialogType === 'copy' ){
      return (
        <DialogFooter>
          <div className={'program-fees-dialog-footer-container'}>
            <div className={'program-fees-legacy-footer'}>
              <span style={{paddingRight: '10px', 'paddingLeft': '10px'}}> Legacy ID </span>
              <EditSectionInput width={'60px'} styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.copySourceRow, 'LEGACY_ID' ) } />
            </div>
            <div className={'program-fees-dialog-footer-error-label'}>{this.state.errorMessage}</div>
            <div className={'program-fees-dialog-footer-buttons'}>
              <button className='dialog-cancel-button' key='btn-sub-dialog-save' onClick={this.onCancelClicked}>Cancel</button>
              <button className={buttonStyle} key='btn-sub-dialog-cancel' onClick={clickAction}>Copy</button>
            </div>
          </div>
        </DialogFooter>
      );

    // Save footer
    } else {
      if( readonly === true ){
        return (
          <DialogFooter>
            <div className={'program-fees-dialog-footer-container'}>
              <div className={'program-fees-legacy-footer'}>
                <span style={{paddingRight: '10px', 'paddingLeft': '10px'}}> Legacy ID </span>
                <EditSectionInput width={'60px'} styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.rowRef, 'LEGACY_ID' ) } />
              </div>
              <div className={'program-fees-dialog-footer-warning-label'}>{'Warning: This fee is outside the current fee period'}</div>
              <div className={'program-fees-dialog-footer-buttons'}>
                <button className='dialog-cancel-button' key='btn-sub-dialog-save' onClick={this.onCancelClicked}>Cancel</button>
                <button className={buttonStyle} key='btn-sub-dialog-cancel' onClick={clickAction}>Save</button>
              </div>
            </div>
          </DialogFooter>
        );
      } else {
        return (
          <DialogFooter>
            <div className={'program-fees-dialog-footer-container'}>
              <div className={'program-fees-legacy-footer'}>
                <span style={{paddingRight: '10px', 'paddingLeft': '10px'}}> Legacy ID </span>
                <EditSectionInput width={'60px'} styles={{backgroundColor: '#F0F0F0'}} readonly={true} value={ readValue( this.state.rowRef, 'LEGACY_ID' ) } />
              </div>
              <div className={'program-fees-dialog-footer-error-label'}>{this.state.errorMessage}</div>
              <div className={'program-fees-dialog-footer-buttons'}>
                <button className='dialog-cancel-button' key='btn-sub-dialog-save' onClick={this.onCancelClicked}>Cancel</button>
                <button className={buttonStyle} key='btn-sub-dialog-cancel' onClick={clickAction}>Save</button>
              </div>
            </div>
          </DialogFooter>
        );
      }
    }
  }

  render(){
    const pos = this.getLocation();
    let styles = {top: 0, left: 0, width: this.state.width, height: this.state.height};
    if( pos ){
      styles.top = pos.y;
      styles.left = pos.x;
    }

    // Setting header style for the dialog so the user can better see where they are
    let dialogHeaderStyle = {
      backgroundColor: '#00796C',
      color: 'white'
    };

    if( this.state.dialogType === 'copy' ){
      dialogHeaderStyle['backgroundColor'] = '#2F424D';
    }

    // Determines if an Edit Fee should be read-only
    let readonlyEdit = false;

    if( this.state.dialogType === 'edit' ){
      let copyDateBegin = '';
      if( this.state.copySourceRow && this.state.copySourceRow['CCFileDateBegin'] ){
        copyDateBegin = this.state.copySourceRow['CCFileDateBegin'];
      }

      readonlyEdit = isFeeOutOfPeriod( this.props.currentFeePeriodStart, copyDateBegin );
      dialogHeaderStyle['backgroundColor'] = '#D8D8D8';
      dialogHeaderStyle['color'] = '#333333';
    }

    return (
      <Dialog width={this.state.width} height={this.state.height} show={this.props.show} style={styles} >
        <DialogHeader style={dialogHeaderStyle} caption={this.props.title} closeButton onClose={this.onCancelClicked} />
        <DialogBody className={'dialog-body'}>
          {this.renderBody( readonlyEdit )}
        </DialogBody>
        {this.renderFooter( readonlyEdit )}
      </Dialog>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ProgramFeesDialog ) );


// WEBPACK FOOTER //
// ./src/presentation/ProgramFeesDialog.js